import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import {
  getStackingDetailsListAction,
  getStackingHistoryListAction,
  submitStakingAction,
} from "../../Action/user.action";
import StakeHistory from "./stakingHistory";
import Dashboardheader from "../../directives/dashboardheader";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import config from "../../config/config";

const Staking = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [stakingData, setStakingData] = useState([]);
  const [vestingBal, setVestingBal] = useState("");
  const [amount, setAmount] = useState();
  const [stakingHistory, setStakingHistory] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [isChecked, setIsChecked] = useState(false); // State for checkbox
  const [stakTerms, setStakTerms] = useState('')
  const [lodingStatus, setlodingStatus] = useState(false);
  const [paginationStatus, setpaginationStatus] = useState(false);

  useEffect(() => {
    getStackingDetailsList();
    loadMoreHistory();
  }, []);

  const handleDivClick = (index, status, planId) => {
    if (status === 1) {
      setActiveIndex(index);
      setSelectedPlanId(planId);
    }
  };

  const getStackingDetailsList = async () => {
    try {
      const res = await getStackingDetailsListAction();
      if (res.success) {
        setStakingData(res.data.staking_plans);
        setVestingBal(res.data.vesting_balance);
        setStakTerms(res.data.terms)
      }
    } catch (error) {
      console.error("Error fetching staking details:", error);
    }
  };

  const loadMoreHistory = async (page = 1) => {
    try {
      const data = {
        page: page,
        limit: 10,
      };
      const res = await getStackingHistoryListAction(data); // Call your action to fetch history
      if (res.success) {
        if (res.data.history.length == 0) {
          setpaginationStatus(true);
        }
        setStakingHistory((prevHistory) => [
          ...prevHistory,
          ...res.data.history,
        ]); // Append new history to existing
      }
    } catch (error) {
      console.error("Error loading more history:", error);
    }
  };

  const StackAmount = async () => {
    setlodingStatus(true)

    if (!isChecked) {
      toast.error("Please check the box to agree to the Terms and Conditions.");
      setlodingStatus(false)

      return;
    }
    if (!selectedPlanId) {
      toast.error("Please select a staking plan.");
      setlodingStatus(false)

      return;
    }

    if (!amount) {
      toast.error("Amount cannot be empty.");
      setlodingStatus(false)

      return;
    }

    if (parseFloat(amount) < 100) {
      toast.error("The minimum staking amount is 100 ANANT.");
      setlodingStatus(false)

      return;
    }
    try {
      const data = {
        amount: amount,
        staking_plan_id: selectedPlanId,
      };
      const res = await submitStakingAction(data);
      if (res.success) {
        setlodingStatus(false)

        toast.success(res.msg)
        setTimeout(() => {
          window.location.reload();
        }, 1000)
      }
      else {
        toast.error(res.msg)
        setlodingStatus(false)

      }

    } catch (error) {
      console.error("Error staking amount:", error);
      setlodingStatus(false)

    }
  };

  const handleMaxClick = () => {
    setAmount(Math.floor(vestingBal));
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,6}(\{0,2})?$/.test(value)) {
      setAmount(value);
    }
  };

  return (
    <>
      <Dashboardheader />
      <div className="position-relative">
        <div className="db1"></div>
        {/* <div className="db2"></div> */}
        {/* <div className="db3"></div> */}
        <div className="db4"></div>
        <div className="db5"></div>
        <div className="db6"></div>
        <div className="db7"></div>
        <div className="db8"></div>
        <Container className=" px-sm-5 px-2  mb-5 text-white  mt-5">
          {/* <div className=" card card-view rounded-20 border-0">

            <div className="card-body">
              <Row className="">
                <Col lg={6} className=" px-sm-5 px-2 py-3">
                  <div className="withdraw_form2">
                    <div className="text-center pb-1">
                      <h3 className="sofia-sans" style={{ fontWeight: 600 }}>Vesting Balance</h3>
                    </div>
                    <div className="text-center sofia-sans mb-4 pb-1">
                      Balance :&nbsp;
                      <span id="web13Balance">{vestingBal} ANANT</span>
                    </div>
                    <div className="mxbtn position-relative">
                      <div>
                        <TextField
                          id="outlined-password-input"
                          label="Amount"
                          type="text"
                          value={amount} 
                          onChange={handleAmountChange}
                          style={{ width: "100%" }}
                          autoComplete="off"
                          placeholder="Enter Amount"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>

                      <button
                        className="pull-right text-white px-4 btn btn-main2 maxamount rounded-2 sofia-sans"
                        type="button"
                        onClick={handleMaxClick}
                      >
                        MAX
                      </button>
                    </div>
                    <div className="d-flex gap-2 py-3">
                      {stakingData?.map((data, index) => (
                        <div
                          key={index}
                          onClick={() =>
                            handleDivClick(index, data.status, data.id)
                          }
                          className={`option ${activeIndex === index
                            ? "active-vesting dash-gradient"
                            : "simple-vesting"
                            }`}
                          style={{
                            cursor: data.status === 1 ? "pointer" : "not-allowed",
                            opacity: data.status === 1 ? 1 : 0.5,
                            pointerEvents: data.status === 1 ? "auto" : "none",
                          }}
                        >
                          <p className="text-white sofia-sans">
                            {data.duration_month} <br />
                            Months
                          </p>
                          <p className="mb-1 sofia-sans" style={{ fontSize: 12 }}>
                            <span
                              style={{
                                fontWeight: 600,
                                color: "white",
                                fontSize: 16,
                              }}
                            >
                              {data.apy}%
                            </span>{" "}
                            &nbsp; APR
                          </p>
                        </div>
                      ))}
                    </div>
                    <div className="d-flex gap-2  mb-3 align-items-center">
                      <div style={{ width: 15 }}>
                        <input
                          className="custom-checkbox mt-1"
                          style={{ width: 15, height: 15 }}
                          type="checkbox"
                          onChange={() => setIsChecked(!isChecked)}
                          name="checkbox"
                          id="flexCheckDefault"
                        />
                      </div>
                      <div className="d-flex gap-1 sofia-sans">
                        <p style={{ marginTop: "1px" }} className="mb-0 sofia-sans">
                          I Agree with the
                        </p>
                        <Link
                          target="blank"
                          className=" tnc"
                          to={`${config.baseUrl}signuptermsandconditions`}
                        >
                          Terms & Conditions{" "}
                        </Link>
                      </div>
                    </div>
                    <Button
                      variant="main2"
                      className="w-100 mb-3"
                      disabled={lodingStatus}
                      onClick={StackAmount}
                    >
                      Stake Now
                    </Button>

                  </div>
                </Col>

                <Col lg={6} className="mt-3">
                  <div className="">
                    <p
                      style={{
                        fontSize: "14px",
                        marginTop: "2.5px",
                      }}
                      dangerouslySetInnerHTML={{ __html: stakTerms }}
                    ></p>
                  </div>
                </Col>
              </Row>
            </div>
          </div> */}
          <br />
          {stakingHistory.length ? <StakeHistory
            stakingHistory={stakingHistory}
            loadMoreHistory={loadMoreHistory}
            paginationStatus={paginationStatus}
          /> :
            <>
              <h3 className='sofia-sans'>Staking History</h3>
              <div
                className="text-center d-flex justify-content-center align-items-center flex-column"
                style={{
                  padding: "20px",
                  color: "#d3d3d3",
                  borderRadius: "8px",
                  height: "80vh",
                }}
              >
                <img
                  style={{ width: "auto", height: "auto" }}
                  src="assets\images\newdesign\nodata-new.png"
                  alt="No Data"
                />
                <h4>No data found</h4>
              </div>
            </>
          }
        </Container>
      </div>
    </>
  );
};

export default Staking;
